import { Bell, History, Pin, Search, Sprout, Briefcase, Trash2 } from 'lucide-react';

export function BellIcon() {
  return <Bell size={16} aria-hidden />;
}

export function HistoryIcon() {
  return <History size={16} aria-hidden />;
}

/** The Pinned Chats section header glyph. */
export function PinIcon() {
  return <Pin size={16} aria-hidden />;
}

export function SearchGlyph() {
  return <Search size={16} aria-hidden />;
}

export function GrowthGoalsIcon() {
  return <Sprout size={16} aria-hidden />;
}

export function AgentsAtWorkIcon() {
  return <Briefcase size={16} aria-hidden />;
}

export function TrashIcon() {
  return <Trash2 size={16} aria-hidden />;
}
